import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useFilterStore, useGraphStore } from '../store.js';

import { HTML2Image } from "../Helpers/HTML2Image";
import FiltersIcon from "../assets/filters-icon.svg";
import CloseIcon from "../assets/close-icon.svg";

const Navigation = () => {
    const allGraphs = useGraphStore((state) => state.allGraphs);
    const isFiltersOpen = useFilterStore((state) => state.isFiltersOpen);
    const toggleFilters = useFilterStore((state) => state.toggleFilters);

    const location = useLocation();

    const [params, setParams] = useState({
        graph: new URLSearchParams(location.search).get('graph'),
        club: new URLSearchParams(location.search).get('selected_club'),
    });

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setParams({
            graph: params.get('graph'),
            club: params.get('selected_club'),
        });
    }, [location.search]);

    return (
        <div className="siteNav-wrapper">
            <nav className="siteNav">
                <ul className="siteNav-list">
                    <li className="siteNav-list-item">
                        <NavLink 
                            exact
                            activeClassName="is-active"
                            to={`/${params.club ? `?selected_club=${params.club}` : ''}`}
                        >
                            All Clubs
                        </NavLink>
                    </li>
                    <li className="siteNav-list-item">
                        <NavLink 
                            activeClassName="is-active"
                            to={`/dashboard${params.club ? `?selected_club=${params.club}` : ''}`}
                        >
                            Dashboard
                        </NavLink>
                    </li>
                    { allGraphs.map((graph, index) =>
                        !graph.hide && (
                            <li className="siteNav-list-item" key={ index }>
                                <NavLink
                                    key={index}
                                    className={`${params.graph === graph.url ? 'is-active' : ''}`}
                                    to={`/detail?graph=${graph.url}${params.club ? `&selected_club=${params.club}` : ''}`}
                                >
                                    {graph.title}
                                </NavLink>
                            </li>
                        )
                    )}
                </ul>

                <button className="button unstyled display-none-down-xxl" onClick={ HTML2Image }>
                    Take Screenshot
                    <svg width="10" height="10" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V12H2V16H6V18H2ZM12 18V16H16V12H18V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H12ZM0 6V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H6V2H2V6H0ZM16 6V2H12V0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V6H16ZM9 14C7.61667 14 6.4375 13.5125 5.4625 12.5375C4.4875 11.5625 4 10.3833 4 9C4 7.61667 4.4875 6.4375 5.4625 5.4625C6.4375 4.4875 7.61667 4 9 4C10.3833 4 11.5625 4.4875 12.5375 5.4625C13.5125 6.4375 14 7.61667 14 9C14 10.3833 13.5125 11.5625 12.5375 12.5375C11.5625 13.5125 10.3833 14 9 14ZM9 12C9.83333 12 10.5417 11.7083 11.125 11.125C11.7083 10.5417 12 9.83333 12 9C12 8.16667 11.7083 7.45833 11.125 6.875C10.5417 6.29167 9.83333 6 9 6C8.16667 6 7.45833 6.29167 6.875 6.875C6.29167 7.45833 6 8.16667 6 9C6 9.83333 6.29167 10.5417 6.875 11.125C7.45833 11.7083 8.16667 12 9 12Z" fill="white"/>
                    </svg>
                </button>
            </nav>

            <button 
                onClick={ toggleFilters }
                className="siteNav-toggle-filters">
                {!isFiltersOpen ? <img width="100%" height="100%" src={FiltersIcon}/> : '' }
                {isFiltersOpen ? <img width="100%" height="100%" src={CloseIcon}/> : '' }
            </button>
        </div>
    );
};

export default Navigation;
